import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import ModalError from "components/UI/Modal/ModalError";
import './stripeCard.css';
import Spinner from '../../../components/UI/Spinner/Spinner';

import { startRequest, finishRequest } from '../../../store/actions'

const PaymentIntentComponent = (props) => {

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [saveCard, setSaveCard] = useState(false);
    const stripe = useStripe();
    const elements = useElements();
    const clientSecretSaveCard = props.clientSecretSaveCard;
    const clientSecretNotSaveCard = props.clientSecretNotSaveCard;

    const dispatch = useDispatch();

    const cardNumberStyle = {
        placeholder: "Card Number"
    };

    const experyCardStyle = {
        placeholder: "MM/YY"
    }

    const securityCardStyle = {
        placeholder: "Security Code"
    };

    const handleChange = async (event) => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    const onChangeSaveCard = () => {
        setSaveCard(!saveCard);
    }

    const closeModalError = () => {
        setIsOpenModal(false)
    }

    const handleSubmitStripe = async (event) => {

        event.preventDefault();
        dispatch(startRequest());
        setProcessing(true);

        const clientSecret = saveCard ? clientSecretSaveCard : clientSecretNotSaveCard;

        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardCvcElement),
            }
        });

        if (payload.error) {
            console.log("error stripe", payload.error.message)
            setError(`Payment failed ${payload.error.message}`);
            setProcessing(false);
            dispatch(finishRequest());
            setIsOpenModal(true)
        } else {
            console.log("Stripe status", payload.status)
            setError(null);
            setProcessing(false);
            setSucceeded(true);
        }
    }

    return (

        <form className="payment-form" onSubmit={handleSubmitStripe} ref={props.formReference}>

            <label className="payment-details">Payment Details</label>
            <div className="stripe-card">

                <label >Card Number</label>
                <CardNumberElement id="card-element" options={cardNumberStyle} onChange={handleChange} />

                <label>Expiry</label>
                <CardExpiryElement id="card-element" options={experyCardStyle} onChange={handleChange} />

                <label>Security Code</label>
                <CardCvcElement id="card-element" options={securityCardStyle} onChange={handleChange} />

                <div className="stripe-save-card">
                    <input type="checkbox" className="checkStripe" value={saveCard} onChange={onChangeSaveCard} />
                    <label className="labelStripe">Save Card Details</label>
                </div>

                <label className="stripe-label-save-card" >
                    These card details can be stored so that subsequent transaction do not
                    require you card details. To avail of this service please tick the checkbox.
                </label>

                {props.isLoading ? (<Spinner nameClass={"lds-secondary"}/>) :
                  <button className="buttonStripe"
                    disabled={processing || disabled || succeeded}
                    id="submit"
                    type="submit"
                  >
                    <span id="button-text">
                         PAY NOW
                    </span>
                </button> }
                <ModalError
                    style={{ zIndex: "99999", position: "absolute", margin: "5% 26%" }}
                    showModal={isOpenModal}
                    closeModal={closeModalError}
                    errorMessage={error}
                />

            </div>
        </form>
    )
}

const mapStateToProps = state => ({
  isLoading: state.loadingReducer.loading
})

export default withRouter(
  connect(mapStateToProps)(PaymentIntentComponent));



// WEBPACK FOOTER //
// ./src/containers/Checkout/Stripe/stripeCard.js